__turbopack_context__.v({
  "buttons-container": "account-module-scss-module__OIX8nq__buttons-container",
  "content": "account-module-scss-module__OIX8nq__content",
  "content-container": "account-module-scss-module__OIX8nq__content-container",
  "fade-in-u0abkza": "account-module-scss-module__OIX8nq__fade-in-u0abkza",
  "fade-in-u0abl01": "account-module-scss-module__OIX8nq__fade-in-u0abl01",
  "fade-in-u0abl10": "account-module-scss-module__OIX8nq__fade-in-u0abl10",
  "main": "account-module-scss-module__OIX8nq__main",
  "section-content": "account-module-scss-module__OIX8nq__section-content",
  "section-title": "account-module-scss-module__OIX8nq__section-title",
  "title": "account-module-scss-module__OIX8nq__title",
  "title-container": "account-module-scss-module__OIX8nq__title-container",
});
